/**
 * @(#)2020/8/6.
 * timeRange，时间范围
 * @author 挽月
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Moment from "moment";
import React, { Component } from "react";
import { DatePicker, TimePicker, Row, Col } from "antd";
import { toArray, get, merge } from "../../../utils";
import { Connection, YxComponent } from "../../YxComponent";
import { isArray, isString, isEqual } from "lodash";

/*
 * -----------------------公共部分参数--------------------------------------------------
 * @param onChange {object} 输入框发生变化的回调，返回对象为一个数组
 * @param startTimeParam {object} 第一个时间选择框的参数，继承TimePicker属性
 * @param endTimeParam {object} 第二个时间选择框的参数，继承TimePicker属性
 * @param defaultValue ["",""] 组件默认时间,格式使用["00:00:00","00:00:00"]
 * */

let defaul = () => {
  return {
    startTimeParam: {},
    endTimeParam: {},
    defaultValue: ["", ""],
  };
};

@Connection(defaul)
class TimeRange extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.state = {
      value: ["", ""], // 用于存储时间字符串
      startTime: "", // 用于时间显示
      endTime: "", // 用于时间显示
    };
  }

  // 时间改变触发回调
  change = (moment, val, idx) => {
    this.state.value[idx] = val;
    this.props.onChange(this.state.value);
    if (idx == 1) {
      this.setState({ endTime: moment });
    } else {
      this.setState({ startTime: moment });
    }
  };

  /**
   * 默认值格式化
   *
   * @memberof Date
   */

  // 时间格式进行转换  TimePicker组件接收moment对象
  format = (tmpProps) => {
    const value = get(tmpProps, "setValue", null);
    const format = tmpProps.format;
    let result = ["", ""];
    if (value && isArray(value) && value.length >= 2) {
      result = toArray(value).map((item) => {
        if (item && typeof item === "string") {
          return Moment(item, format);
        } else {
          return item;
        }
      });
    }
    return result;
  };

  getRangParam() {
    let tmpProps = this.props;
    const defaultVal = this.format(tmpProps);
    if (defaultVal) {
      this.setState({ startTime: defaultVal[0], endTime: defaultVal[1] });
    }
  }

  componentWillMount() {
    this.getRangParam();
  }

  componentWillReceiveProps(nextProps) {
    let tmpProps = this.props;
    let value = get(tmpProps, "setValue");
    let nextValue = get(nextProps, "setValue");
    let nextTime = this.format(nextProps);
    if (nextValue && isArray(nextValue) && !isEqual(nextValue, value)) {
      this.setState({ startTime: nextTime[0], endTime: nextTime[1] });
    }
    if (!nextValue && nextTime && isArray(nextTime)) {
      this.setState({ startTime: nextTime[0], endTime: nextTime[1] });
    }
  }

  paramError(tmpProps) {
    const value = get(tmpProps, "setValue");
    if (value && !isArray(value)) {
      console.error("value参数格式不准确，正确格式为['00:00:00','00:00:00']");
    }
    const initValue = get(tmpProps, "initValue");
    if (initValue && !isArray(initValue)) {
      console.error(
        "defaultValue参数格式不准确，正确格式为['00:00:00','00:00:00']"
      );
    }
  }

  render() {
    let tmpProps = this.props;
    this.paramError(tmpProps);

    // startTimeParam开始时间参数
    let startTimeParam = {
      id: tmpProps.id + "_start",
      onChange: (valuesMoment, values) => {
        this.change(valuesMoment, values, 0);
      },
      value: this.state.startTime,
      ...tmpProps.startTimeParam,
      format: tmpProps.format,
    };
    // startTimeParam = merge(startTimeParam, tmpProps);

    //startTimeParam结束时间参数
    let endTimeParam = {
      id: tmpProps.id + "_end",
      onChange: (valuesMoment, values) => {
        this.change(valuesMoment, values, 1);
      },
      value: this.state.endTime,
      ...tmpProps.endTimeParam,
      format: tmpProps.format,
    };

    // endTimeParam = merge(endTimeParam, tmpProps);

    return (
      <Row>
        <Col span={24}>
          <TimePicker {...startTimeParam}></TimePicker>
        </Col>
        <Col
          span={4}
          type="flex"
          className="yx_yxInput_range_interval"
          justify="center"
          align="center"
        >
          -
        </Col>
        <Col span={24}>
          <TimePicker {...endTimeParam}></TimePicker>
        </Col>
      </Row>
    );
  }
}

export default TimeRange;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Date/TimeRange.js